import { useContext } from 'react';
import GatewayContagemContext from '../GatewayContagemContext';

const useGatewayContagem = () => useContext(GatewayContagemContext);

export default useGatewayContagem;
